export const MINING_EVENT_LIST_REQUEST = 'MINING_EVENT_LIST_REQUEST';

export const MINING_EVENT_LIST = 'MINING_EVENT_LIST';

export const MINING_EVENT_RESPONSE_MESSAGE = 'MINING_EVENT_RESPONSE_MESSAGE';

export const MINING_EVENT_CREATE_REQUEST = 'MINING_EVENT_CREATE_REQUEST';

export const MINING_EVENT_INFO_DETAILS_REQUEST = 'MINING_EVENT_INFO_DETAILS_REQUEST';

export const MINING_EVENT_INFO_DETAILS = 'MINING_EVENT_INFO_DETAILS';

export const MINING_EVENT_INFO_UPDATE_REQUEST = 'MINING_EVENT_INFO_UPDATE_REQUEST';

export const MINING_EVENT_INFO_DELETE_REQUEST = 'MINING_EVENT_INFO_DELETE_REQUEST';

export const SET_TOTAL_COUNT = 'SET_TOTAL_COUNT';

export const SET_MINING_EVENT_PAGINATION = 'SET_MINING_EVENT_PAGINATION';

export const MINING_EVENT_PAGE_RESET = 'MINING_EVENT_PAGE_RESET';

export const MINING_EVENT_DEPOSIT_REQUEST = 'MINING_EVENT_DEPOSIT_REQUEST';

export const MINING_EVENT_ADD_BUDGET = 'MINING_EVENT_ADD_BUDGET';
